import { useRuntimeConfig } from '#app'
import { Mode } from '@/types/environment'

/* Получить домейн первого уровня (ru/com/kg...) */
const getCountryDomain = (hostname: string) => {
  const MODE = useRuntimeConfig().public.MODE || process.env.ENV

  let domain = hostname.split('.').slice(-1)[0]

  if (Mode.DEVELOPMENT === MODE) {
    domain = 'ru'
  }

  return domain
}

/* Получить API_URL с динамическим domain 1-ого ур. (ru, kg, com...) */
export const getApiUrlWithDynamicDomain = (
  apiUrl: string,
  host: string,
  mode: Mode,
) => {
  let url: string | string[] = apiUrl

  if (Mode.DEVELOPMENT !== mode) {
    const domain = getCountryDomain(host)
    url = apiUrl.split('.')
    url.splice(-1, 1, domain)
    url = url.join('.')
  }

  return url
}
